import React, { createContext } from 'react';

export const VpcsContext = createContext<any | undefined>(undefined);
